module.exports = __webpack_public_path__ + "static/media/cacSalads.652fb920.jpg";